import { gql } from "@apollo/client";
import { skipToken, useSuspenseQuery } from "@apollo/client/react";

import ProductLine from "./ProductLine.graphql";

interface IProductLine {
    id: string

    brandID: string
    key: string

    name: {
        language: string
        text: string
    }[]
    image: string
    parameterIDs: string[]
}

export default function useProductLine(id: string) {
    return useSuspenseQuery<{ productLine: IProductLine }>(
        gql(ProductLine),
        id
            ? {
                variables: {
                    id,
                },
            }
            : skipToken,
    );
}
